import { createFileRoute } from "@tanstack/react-router";
import PropUnreleasedBatchesTab from "lib/components/debug/PropUnreleasedBatchesTab";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../components/withAuthentication";

function PropAwsAdmin() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Prop AWS Admin")}</title>
      </Head>

      <div className="ui" style={{ padding: "10px" }}>
        <h2>Prop AWS Admin</h2>

        <div style={{ padding: "10px 0" }}>
          <PropUnreleasedBatchesTab
            onPickBatch={(fileName) => {
              window.location.href = `/debug/prop-aws-batch?activeBatch=${encodeURIComponent(fileName)}`;
            }}
          />
        </div>
      </div>
    </>
  );
}

export const Route = createFileRoute("/debug/prop-aws-admin")({
  component: withAuthentication(PropAwsAdmin, { superAdmin: true }),
});
